import { white } from '@kmns-internal/furikake'
import { Add } from '@mui/icons-material'
import {
  Button,
  Stack,
  Table,
  TableContainer,
  TablePagination,
} from '@mui/material'
import type { FC } from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Loading from 'src/components/loading/Loading'
import { TemplateTabsHeader } from 'src/features/template/components/TemplateTabsHeader'
import {
  changeMultipleChoiceSetsPage,
  changeMultipleChoiceSetsSize,
  getMultipleChoiceSets,
} from 'src/state/ducks/multipleChoiceSets/actions'
import type { RootState } from 'src/state/store'
import MultipleChoiceSetList from './MultipleChoiceSetList'

const MultipleChoiceSetsContainer: FC = () => {
  const multipleChoiceSets = useSelector(
    (state: RootState) =>
      state.multipleChoiceSetsState.multipleChoiceSets.multipleChoiceSets,
  )
  const isLoading = useSelector(
    (state: RootState) =>
      state.multipleChoiceSetsState.multipleChoiceSets.isLoading,
  )
  const count = useSelector(
    (state: RootState) =>
      state.multipleChoiceSetsState.multipleChoiceSets.count,
  )
  const request = useSelector(
    (state: RootState) =>
      state.multipleChoiceSetsState.multipleChoiceSets.request,
  )

  const dispatch = useDispatch()
  const history = useHistory()
  const goAddMultipleChoiceSet = () => {
    history.push('/multipleChoiceSets/add')
  }

  useEffect(() => {
    dispatch(getMultipleChoiceSets(request))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // MUI TablePagination は 0 オリジン
  const currentPage =
    request.offset === undefined || request.limit === undefined
      ? 0
      : Math.trunc(request.offset / request.limit)

  return (
    <Stack>
      <TemplateTabsHeader activeTab="multipleChoiceSets" />
      <Stack direction="row" justifyContent="flex-end" p={2}>
        <Button
          color="primary"
          variant="contained"
          startIcon={<Add />}
          onClick={goAddMultipleChoiceSet}
        >
          セット選択肢を追加
        </Button>
      </Stack>
      {isLoading ? (
        <Loading />
      ) : (
        <TableContainer sx={{ overflow: 'auto', flexGrow: 1, bgcolor: white }}>
          <Table sx={{ bgcolor: white, width: '100%' }} stickyHeader>
            <MultipleChoiceSetList multipleChoiceSets={multipleChoiceSets} />
          </Table>
        </TableContainer>
      )}
      <TablePagination
        component="div"
        count={count}
        page={currentPage}
        onPageChange={(_, newPage) =>
          // changeMultipleChoiceSetsPage の第一引数は 1 オリジン
          dispatch(changeMultipleChoiceSetsPage(newPage + 1, request.limit))
        }
        rowsPerPage={request.limit ?? 25}
        onRowsPerPageChange={event =>
          dispatch(
            changeMultipleChoiceSetsSize(parseInt(event.target.value, 10)),
          )
        }
        // 25, 50, 100 を選択肢とする
        rowsPerPageOptions={[25, 50, 100]}
        labelRowsPerPage="1ページあたり:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}〜${to} (${count !== -1 ? count : '不明'} 件中)`
        }
        sx={{
          '& .MuiTablePagination-selectLabel': { margin: 0 },
          '& .MuiTablePagination-displayedRows': { margin: 0 },
        }}
      />
    </Stack>
  )
}

export default MultipleChoiceSetsContainer
